export default __webpack_public_path__ + "static/media/logo.8d9fecf6.svg";